import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Fast, Reliable Roadside Assistance Across the UK</h1>
        <p>
          24/7 support for breakdowns, mechanical issues, and emergency roadside
          situations. Delivered exclusively through FCA‑authorised partners.
        </p>
        <a href="/services" className="hero-btn">Get Assistance Now</a>
      </div>
    </section>
  );
}
